import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import * as Sentry from '@sentry/react';
import { router } from './router';
import '@/styles/global.css';

Sentry.init({
  dsn: 'https://585410fae748b287b6ec1d6a6873f0a8@o4508071568998400.ingest.us.sentry.io/4510808342265856',
  environment: import.meta.env.MODE, // 'development' or 'production'
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

function SentryFallback() {
  return (
    <div className='min-h-screen flex items-center justify-center p-6 bg-sky-light'>
      <div className='text-center max-w-md'>
        <h1 className='text-xl font-bold text-gray-900 mb-2'>Something went wrong</h1>
        <p className='text-gray-600 mb-4'>
          An unexpected error occurred. Please refresh the page and try again.
        </p>
        <button
          type='button'
          onClick={() => window.location.reload()}
          className='px-4 py-2 rounded-xl bg-primary text-white font-semibold hover:bg-primary/90'
        >
          Refresh
        </button>
      </div>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<SentryFallback />}>
      <RouterProvider router={router} />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

